import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>¡¡Novedades de la versión!!</h3>

        <ul className="lista-cambios">
          <li>HISTORIAL CLINICO:
            <ul>
              <li className="lista-cambios 2">Se ha habilitado un filtro en la cabecera del historial para filtrar las actuaciones del paciente</li>
            </ul>
          </li>          
          <li>CIERRE DIARIO:
            <ul>
              <li className="lista-cambios 2">Nuevo botón "Cierre día" en cabecera aplicación</li>
              <li className="lista-cambios 2">Muestra las actuaciones pagadas del día actual para facilitar la comprobación del cierre</li>
            </ul>
          </li>
          <li>RECALLS:
            <ul>
              <li className="lista-cambios 2">Habilitadas todas las opciones de fechas para realizar los recall (añadidos meses y semanas faltantes)</li>
            </ul>
          </li> 
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Ya funciona el odontograma, solamente al entrar un nuevo tratamiento, comprobar que no existe otro llamdo igual</li>
          <li>Cualquier duda o error, contactar con Raúl.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
